import { faInfoCircle, faCircleXmark } from '@fortawesome/pro-solid-svg-icons';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';

export type IconVariantType = 'alert' | 'circle-mark';

export const iconSelector = new Map<IconVariantType, IconDefinition>([
    ['alert', faInfoCircle],
    ['circle-mark', faCircleXmark]
]);
